module.exports = __webpack_public_path__ + "static/media/mc-picanha.b113bce4.png";